import { Pagination, Typography } from '@mui/material'
import React from 'react'

export default function PaginationComp({data,entries, totalPages, currentPage, handlePageChange}) {
    return (
        <>
            {data?.length > 0 && <div className="border-t-2 border-t-primary-foreground p-3 flex items-center justify-between h-[15%]">
                <Typography className="text-muted !text-h4">
                    Showing data {entries.from} to {entries.to} of {entries.entry} entries
                </Typography>
                <Pagination
                    sx={{ marginLeft: 'auto' }}
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    variant="outlined"
                    shape="rounded"
                />
            </div>}
        </>
    )
}
